import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import * as Parse from 'parse';
import { OrganizationService } from './organization.service';

export enum CONTRACT_PAGE_CATEGORY {
    MY_TEMPLATE = 'my-template',
    GLOBAL = 'global',
    PENDING = 'pending'
}

export enum CONTRACT_TEMPLATE_TYPE {
    OFFER = 'offer',
    SALES = 'sales',
    OTHER = 'other'
}

export enum CONTRACT_TEMPLATE_STATUS {
    PENDING = 'pending',
    READY = 'ready',
    PUBLISHED = 'published'
}

export enum CONTRACT_TEMPLATE_ORIGIN {
    MANUAL = 'manual',
    PDFIX = 'pdfix'
}

@Injectable()
export class ContractTemplateService {

    constructor(private auth: AuthService, private orgService: OrganizationService) {
    }

    fetchTemplates(type: CONTRACT_PAGE_CATEGORY): Promise<Parse.Object[]> {
        const query: Parse.Query = new Parse.Query('ContractTemplate');
        query.equalTo('organization', this.orgService.organization);

        if (type === CONTRACT_PAGE_CATEGORY.MY_TEMPLATE) {
            query.equalTo('isGlobal', false);
            query.equalTo('owner', this.auth.currentUser);

            return query.find();
        } else if (type === CONTRACT_PAGE_CATEGORY.GLOBAL) {
            query.equalTo('isGlobal', true);
            query.equalTo('status', CONTRACT_TEMPLATE_STATUS.PUBLISHED);

            if (this.auth.userType === 'SA') {
                query.containedIn('type', [CONTRACT_TEMPLATE_TYPE.SALES, CONTRACT_TEMPLATE_TYPE.OTHER]);
            } else if (this.auth.userType === 'AAA') {
                query.containedIn('type', [CONTRACT_TEMPLATE_TYPE.OFFER, CONTRACT_TEMPLATE_TYPE.OTHER]);
            }

            return query.find();
        } else if (type === CONTRACT_PAGE_CATEGORY.PENDING) {
            query.equalTo('isGlobal', true);
            query.notEqualTo('status', CONTRACT_TEMPLATE_STATUS.PUBLISHED);

            return query.find();
        }

        return Promise.resolve([]);
    }

    createTemplate(templateName: string, file: File): Promise<Parse.Object> {
        const template: Parse.Object = new Parse.Object('ContractTemplate');

        template.set('name', templateName);
        template.set('isGlobal', true);
        template.set('owner', this.auth.currentUser);
        template.set('organization', this.orgService.organization);

        if (file) {
            template.set('status', CONTRACT_TEMPLATE_STATUS.PENDING);
            template.set('originType', CONTRACT_TEMPLATE_ORIGIN.PDFIX);

            // Upload File
            const sourceFile = new Parse.File(Math.random().toString(16).replace('.', '_'), file);
            template.set('sourceFile', sourceFile);

        } else {
            template.set('status', CONTRACT_TEMPLATE_STATUS.READY);
            template.set('originType', CONTRACT_TEMPLATE_ORIGIN.MANUAL);
        }

        return template.save();
    }

    deleteTemplate(template: Parse.Object): Promise<Parse.Object> {
        return template.destroy();
    }

    copyTemplate(template: Parse.Object): Promise<Parse.Object> {
        const copy: Parse.Object = template.clone();

        copy.set('isGlobal', false);
        copy.set('owner', this.auth.currentUser);
        copy.set('original', template);

        return copy.save();
    }

    publishTemplate(template: Parse.Object): Promise<Parse.Object> {
        template.set('status', CONTRACT_TEMPLATE_STATUS.PUBLISHED);
        return template.save();
    }

    unPublishTemplate(template: Parse.Object): Promise<Parse.Object> {
        template.set('status', CONTRACT_TEMPLATE_STATUS.READY);
        return template.save();
    }

    startTemplateConversion(template: Parse.Object) {
        return Parse.Cloud.run('startPDFtoHTMLConversion', { templateId: template.id });
    }
}
